<template>
  <div class="impact-pie-container">
    <PieChart :entries="summaryPie(data.site)" :radius="radius" :inner-radius="innerRadius" />
    <div class="label-box">
      <span class="label-per improvement">
        <AnimatedValue :value="averageCount(data.site.improvement.count)" /><small>% </small><span class="flag">{{ $t('improvement') }}</span>
      </span>
      <span class="label-per decay">
        <AnimatedValue :value="averageCount(data.site.decay.count)" /><small>% </small><span class="flag">{{ $t('degradation') }}</span>
      </span>
      <span class="label-per flag">
        <span class="flag"
          ><i class="icon-alert" /><AnimatedValue :value="data.site.sensibleCaseDecay.count" /> {{ $t('outliers', data.site.sensibleCaseDecay.count) }}</span
        >
      </span>
    </div>
  </div>
</template>

<script>
import AnimatedValue from '@/components/AnimatedValue';
import PieChart from '@/components/Chart/Pie';

export default {
  components: {
    AnimatedValue,
    PieChart,
  },

  props: ['data'],

  computed: {
    total() {
      return this.data.attributes.total;
    },

    radius() {
      return this.data.attributes.radius;
    },

    innerRadius() {
      return this.data.attributes.innerRadius;
    },
  },

  methods: {
    averageCount(value) {
      return this.total === 0 ? 0 : (value / this.total) * 100;
    },

    summaryPie(data) {
      return [
        {
          count: data.decay.count,
        },
        {
          count: data.improvement.count,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
.impact-pie-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .table-gabarit & {
    width: 236px;
    flex-direction: row;
    .pie-chart-container {
      margin-top: 0;
      flex: 1;
      justify-content: center;
      display: flex;
    }
  }
}
.label-box {
  width: 100%;
  display: flex;
  justify-content: space-around;
  position: relative;
  top: -10px;
  .label-per {
    font-size: 18px;
    color: #262631;
    line-height: 1.2;
  }
  small {
    font-size: 0.4571428571em;
  }
  .flag {
    display: none;
    font-size: 14px;
  }
  .improvement {
    color: #1daea1;
  }
  .decay {
    color: #bc141a;
  }
  .table-gabarit & {
    flex-direction: column;
    width: 128px;
    padding-right: 16px;
    position: static;
    top: initial;
    .label-per {
      font-size: 20px;
    }
    .improvement {
      color: #262631;
    }
    .decay {
      color: #262631;
    }
    .flag {
      display: inline;
    }
  }
}
</style>
